import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDoubleLeft, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionNavigation',
    props: {
        historyName: null,
        selectedCollections: null
    },
    emits: ["update:selected-collections"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faAngleDoubleLeft, faAngleLeft);
        const previousName = computed(() => {
            const length = props.selectedCollections.length;
            if (length > 1) {
                const last = props.selectedCollections[length - 2];
                return last === null || last === void 0 ? void 0 : last.name;
            }
            return null;
        });
        function back() {
            const newList = props.selectedCollections.slice(0, -1);
            emit("update:selected-collections", newList);
        }
        function close() {
            emit("update:selected-collections", []);
        }
        return { __sfc: true, props, emit, previousName, back, close, faAngleDoubleLeft, faAngleLeft, FontAwesomeIcon, BButton };
    }
});
